import { useSearchParams } from 'react-router'

export function usePreviewESignatureLetterModal() {
  const [searchParams, setSearchParams] = useSearchParams()

  function showPreview(agreementId: number) {
    searchParams.set(
      PREVIEW_ESIGNATURE_LETTER_MODAL_PARAMS.isPreviewingESignatureLetterForAgreementId,
      agreementId.toString(),
    )
    setSearchParams(searchParams, { replace: true })
  }

  function hidePreview() {
    searchParams.delete(
      PREVIEW_ESIGNATURE_LETTER_MODAL_PARAMS.isPreviewingESignatureLetterForAgreementId,
    )
    setSearchParams(searchParams, { replace: true })
  }

  return {
    isShowing: searchParams.has(
      PREVIEW_ESIGNATURE_LETTER_MODAL_PARAMS.isPreviewingESignatureLetterForAgreementId,
    ),
    showPreview,
    hidePreview,
  }
}

export const PREVIEW_ESIGNATURE_LETTER_MODAL_PARAMS = {
  isPreviewingESignatureLetterForAgreementId:
    'isPreviewingESignatureLetterAgreementId',
}
